import React, { useCallback } from 'react';
import { get } from 'lodash';
import CheckBox from '../../../../../../../common/components/Checkbox';
import ChatbotModel, { ChannelName } from '@mm/state/model/ChatbotModel';
import { Heading } from '@mm/components';
import { ChatbotChannelsCheckmarks } from '../../../../components/ChatbotChannelsCheckmarks/ChatbotChannelsCheckmarks';

type Props = {
  chatbot: ChatbotModel;
  updateChatbot: (chatbot: ChatbotModel) => void;
};

export const ChatBotQandAOptions = ({ chatbot, updateChatbot }: Props) => {
  const messagesSettings =
    chatbot.messagesSettings || ({} as ChatbotModel['messagesSettings']);

  const onChannelMessagingToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;

    if (!messagesSettings) {
      return;
    }

    messagesSettings.processNotDefinedQqAnswerByTriggers = {
      ...messagesSettings?.processNotDefinedQqAnswerByTriggers,
      [name]: checked,
    };

    updateChatbot({ ...chatbot, messagesSettings });
  };

  const onMisspellingCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    updateChatbot({ ...chatbot, qaMisspellingEnabled: e.target.checked });
  };

  const isChecked = useCallback(
    (channel: ChannelName) =>
      get(
        chatbot,
        `messagesSettings.processNotDefinedQqAnswerByTriggers.${channel}`,
      ),
    [chatbot.messagesSettings?.processNotDefinedQqAnswerByTriggers],
  );

  return (
    <>
      <CheckBox
        isChecked={chatbot.qaMisspellingEnabled}
        label="Use misspelling for Q&A"
        onToggle={onMisspellingCheckboxChange}
      />
      <br />

      <Heading size={3}>
        Check Q&A when user types answer to a Quick Question
      </Heading>

      <ChatbotChannelsCheckmarks
        isChecked={isChecked}
        onToggle={onChannelMessagingToggle}
      />
    </>
  );
};
